// ==========================
// Version 4 — mapsConfig.js (adds 'marker' library; keeps Map ID helper)
// ==========================
const mapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const mapId = process.env.REACT_APP_GOOGLE_MAP_ID || null;

if (!mapsKey) {
  // eslint-disable-next-line no-console
  console.error('Missing REACT_APP_GOOGLE_MAPS_API_KEY. Put it in .env.local (no quotes).');
}

export const MAPS_LOADER_OPTIONS = {
  id: 'google-maps-script-v2',
  googleMapsApiKey: mapsKey,
  libraries: ['marker'], // <-- needed for AdvancedMarkerElement / PinElement
};

// Common map options helper — spreads mapId only if provided
export function withBrandMapOptions(extra = {}) {
  const base = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: true,
  };
  return mapId ? { ...base, mapId, ...extra } : { ...base, ...extra };
}

export const MAP_ID = mapId;
// ==========================
// End Version 4 — mapsConfig.js
// ==========================
